//-- Copyright (c) 2021 TMT Insights Group, LLC
import { formatDate, getAgeFromDate } from '@/_utils/date';
import TableStatus from '../_common/Table/TableStatus';
import OverflowMenu from '../_common/OverflowMenu/OverflowMenu';
import History from '../_common/History/History';
import TaskResolve from '../_common/Tasks/TaskResolve';
import {  OrderJobTask, TitleEntity } from '@/redux/slices/slice_types';
import DateTimeDisplay from '../_common/DateTimeDisplay';

export default {
  hid: {
    label: 'Task ID',
    sortField: 'id',
    render: (cell: OrderJobTask['hid']) => <strong>{cell}</strong>
  },
  job__due_date: {
    label: 'Due Date',
    width: 100,
    render: (cell: OrderJobTask['job']['due_date']) => formatDate(cell)
  },
  created_at_dateformat: {
    sortField: 'created_at',
    label: 'Created',
    minWidth: 120,
    render: (_cell: OrderJobTask['created_at'], row: OrderJobTask) => <DateTimeDisplay>{row.created_at}</DateTimeDisplay>
  },
  created_at: {
    label: 'Age',
    minWidth: 120,
    render: (cell: OrderJobTask['created_at']) => getAgeFromDate(cell)
  },
  job__id: {
    label: 'Related Job',
    render: (cell: OrderJobTask['job']['id']) => (
      <a href={`/jobs/${cell}`} style={{ textDecoration: 'none', color: 'var(--primary-main)' }}>
        <strong>J{cell}</strong>
      </a>
    )
  },
  job__title__name: {
    label: 'Title',
    render: (cell: TitleEntity['name']) => <strong>{cell}</strong>
  },
  status: {
    label: 'Status',
    render: (cell: OrderJobTask['status'], row: OrderJobTask) => (
      <TableStatus status={cell} labelOverride={row.pretty_name} statusReason={row.status_reason} />
    )
  },
  overflow: {
    label: '',
    isOverflow: true,
    render: (_cell: any, row: OrderJobTask) => (
      <OverflowMenu>
        <History data={row} />
        {!!row.status_reason && row.status !== 'resolved' && <TaskResolve task={row} />}
      </OverflowMenu>
    )
  }
};
